import { render, staticRenderFns } from "./Daily.vue?vue&type=template&id=506660ca&scoped=true"
import script from "./Daily.vue?vue&type=script&lang=js"
export * from "./Daily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506660ca",
  null
  
)

export default component.exports